import '../../style/store/store product/SP_Info.css';

import icon1 from '../../../assets/store/stickynote2.png';
import icon2 from '../../../assets/store/teacher.png';
import icon3 from '../../../assets/store/people.png';
import icon4 from '../../../assets/store/profile-2user.png';
import icon5 from '../../../assets/store/clock.png';
const SP_Info =({title,level,max_user,type,creator,about,date,time})=>{
  return(
    <div className="sp-info">
      <div className="sp-info-title">ویژگی‌های آزمون</div>
      <div className="sp-info-row1">
        <div className="sir1-name-box">
          <img src={icon1} alt="name-icon" />
          <div className="sir1-name-box-title">نام آزمون:</div>
          <div className="sir1-name-box-title-value">{title}</div>
        </div>
        <div className="sir1-level-box">
          <img src={icon2} alt="level-icon" />
          <div className="sir1-level-box-title">پایه تحصیلی:</div>
          <div className="sir1-level-box-title-value">{level}</div>
        </div>
        <div className="sir1-max-user-box">
          <img src={icon3} alt="max-user-icon" />
          <div className="sir1-max-user-box-title">حدنصاب شرکت کنندگان:</div>
          <div className="sir1-max-user-box-title-value">{max_user}</div>
        </div>
        <div className="sir1-type-box">
          <img src={icon4} alt="type-icon" />
          <div className="sir1-type-box-title">نوع شرکت در آزمون:</div>
          <div className="sir1-type-box-title-value">
            {type===1 && "انفرادی"}
            {type===2 && "گروهی"}
          </div>
        </div>
      </div>
      <div className="sp-info-row2">
        <div className="spir2-date-box">
          <img src={icon5} alt="spir2-date-box-icon" className="spir2-date-box-icon" />
          <div className="spir2-date-box-title">زمان آزمون:</div>
          <div className="spir2-date-box-date">{date}</div>
          <div className="spir2-date-box-time">ساعت {time}</div>
        </div>
        <div className="spir2-creator-box">
          <div className="spir2-creator-box-avatar-container">
            <img src={creator.avatar} alt="" className="pir2-creator-box-avatar" />
          </div>
          <div className="spir2-creator-box-title">ایجاد شده توسط:</div>
          <div className="spir2-creator-box-value">{creator.name}</div>
        </div>
      </div>
      <div className="sp-info-about">
        <div className="sp-info-about-title">درباره آزمون</div>
        <div className="sp-info-about-value">{about}</div>
      </div>
    </div>
  )
}

export default SP_Info;